import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import { BlockBackgroundColorWrapper } from "@/components/editor/shared/block-wrapper";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";

export const Wrapper = styled.div`
  position: relative;

  .background-squiggle:nth-child(1) {
    position: absolute;
    top: 0;
    left: 39%;
  }

  .background-squiggle:nth-child(2) {
    position: absolute;
    top: 460px;
    right: 8%;
    transform: rotate(-22deg);
  }
`;

const PaddedBlockBackground = withViewportStyle(BlockBackgroundColorWrapper)`
  ${(props) => props.$viewport.tablet`
    padding-top: ${rem(48)};
    padding-left: ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    padding-left: ${rem(16)};
  `}
`;

const Container = withViewportStyle("div")`
  position: relative;
  display: grid;
  grid-template-columns: 0.483fr 0.5169fr;
  grid-column-gap: ${rem(24)};
  padding-bottom: ${rem(156)};

  ${(props) => props.$viewport.tablet`
    grid-template-columns: 1fr;
    grid-column-gap: unset;
    grid-row-gap: ${rem(32)};
    padding-bottom: unset;
  `}
`;

const Content = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${rem(24)};
  align-content: end;
  padding-top: ${rem(48)};
  padding-left: ${rem(108)};

  .text-primitive {
    text-align: left;
  }

  .ck-content h1,
  .ck-content h2,
  .ck-content h3,
  .ck-content h4,
  .ck-content h5,
  .ck-content p {
    margin: 0;
  }

  ${(props) => props.$viewport.tablet`
    padding-top: unset;
    padding-left: unset;
    padding-right: ${rem(24)};

    .text-primitive,
    .ck-content h1,
    .ck-content h2,
    .ck-content h3,
    .ck-content h4,
    .ck-content h5,
    .ck-content p {
      text-align: center;
    }
  `}

  ${(props) => props.$viewport.mobile`
    padding-right: ${rem(16)};
  `}
`;

const ImageWrapper = withViewportStyle("div")`
  width: 100%;
  max-width: ${rem(732)};
  height: ${rem(624)};
  
  ${(props) => props.$viewport.tablet`
    max-width: unset;
    height: ${rem(525)};
    padding-left: ${rem(16)};
  `}

  ${(props) => props.$viewport.mobile`
    height: ${rem(443)};
  `}
`;

const Image = withViewportStyle("img")<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.imageFit || "cover"};
  object-position: ${(props) => props.$position};
  overflow: hidden;
  border-bottom-left-radius: ${rem(20)};

  ${(props) => props.$viewport.tablet`
    border-bottom-left-radius: unset;
    border-top-left-radius: ${rem(20)};
  `}
`;

const LogoWrapper = withViewportStyle("div")`
  height: 100%;
  display: flex;
  align-items: center;

  ${(props) => props.$viewport.tablet`
    justify-content: center;
  `}
`;

const Logo = withViewportStyle("img")<{ isLogoResized: boolean }>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(35))};
    margin-bottom: ${rem(32)};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(31))};
    margin-bottom: ${rem(24)};
  `}
`;

const ButtonWrapper = withViewportStyle("div")`
  width: 100%;
  max-width: ${rem(180)};

  .button-primitive {
    ${baseButtonStyle}
    width: 100%;
  }

  ${(props) => props.$viewport.tablet`
    margin: 0 auto;
  `}
`;

export {
  PaddedBlockBackground,
  Container,
  Content,
  Logo,
  LogoWrapper,
  ImageWrapper,
  Image,
  ButtonWrapper,
};
